import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type InkTone, inkToneVariants } from '@lite-workspace/shared/helm-ui/spinner';
import { classes } from '@lite-workspace/shared/helm-ui/utils';
import { ICON_REGISTRY, type IconName } from './icon-registry.generated';

@Component({
  selector: 'app-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  host: {
    role: 'img',
    'aria-hidden': 'true',
    class: 'inline-block shrink-0 bg-current align-[-0.125em]',
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
    '[style.-webkit-mask]': 'mask()',
    '[style.mask]': 'mask()',
  },
})
export class IconComponent {
  readonly name = input.required<IconName>();
  readonly size = input(16);
  readonly tone = input<InkTone>('inherit');

  // The mask reads the svg's alpha, not its colour — the generator strips opacity so it can't dim currentColor.
  protected readonly mask = computed(() => `url("${ICON_REGISTRY[this.name()]}") center / contain no-repeat`);

  constructor() {
    classes(() => inkToneVariants({ tone: this.tone() }));
  }
}
